import { CREATE_USER, VERIFY_OTP_NUMBER , API_ERROR, CREATE_USER_SUCCESS,VERIFY_OTP_NUMBER_SUCCESS, GET_ACCOUNT_INFO} from "./actionTypes";

export const createUser = (user, history) => {
    return {
      type: CREATE_USER,
      payload: { user, history },
    }
  }
  
  export const loginotpUpdate = (user, history) => {
    return {
      type: VERIFY_OTP_NUMBER,
      payload: { user, history },
    }
  }

  export const getAccountInfo = (user, history) => {
    return {
      type: GET_ACCOUNT_INFO,
      payload: { user, history },
    }
  }
  
  export const createUserSuccess = user => {
    return {
      type: CREATE_USER_SUCCESS,
      payload: user,
    }
  }
  
  export const oginotpSucces = history => {
    return {
      type: VERIFY_OTP_NUMBER_SUCCESS,
      payload: { history },
    }
  }
  
  export const apiError = error => {
    return {
      type: API_ERROR,
      payload: error,
    }
  }